<template>
    <fade-transition :duration="666" @afterLeave="afterLeave">
        <div class="modal-mask" v-show="showing" @click="closeMask"></div>
    </fade-transition>
</template>

<script>
    import { FadeTransition } from 'vue2-transitions'
    export default {
        name: 'helpMask',
        components: { FadeTransition },
        data() {
            return {
                showing: false
            }
        },
        methods: {
            closeMask() {  // 模态框关闭事件
                this.showing = false
                // 执行回调
                this.onClose()
            },
            afterLeave() {  // 过渡动画完成 移除DOM
                this.$helpMask.close()
            }
        }
    }
</script>

<style lang='scss' scoped>
    .modal-mask {
        position: fixed;
        z-index: 1110;
        top: 0; bottom: 0;
        left: 0; right: 0;
        background: rgba(0, 0, 0, .3);
    }
</style>


// WEBPACK FOOTER //
// src/components/uimask/src/main.vue